import "normalize.css";
import "animate.css";
import "./global.css";
import { useComponentsQuery } from "./hooks/queries/useComponentsQuery";
import Routes from "./services/routes";
import FrameGuard from "./components/elements/frame-guard";
import PageLoader from "./components/elements/page-loader";

function App() {
  const { isLoading } = useComponentsQuery();
  const isReady = !isLoading;

  return (
    <FrameGuard>
      <PageLoader visible={!isReady} />
      <div className={`transition-opacity duration-500 ${isReady ? "opacity-100" : "opacity-0"}`}>
        <Routes />
        
      </div>
    </FrameGuard>
  );
}

export default App;
